"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getCacheValue = function (key) {
    var value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
};
var setCacheValue = function (key, value) { return sessionStorage.setItem(key, JSON.stringify(value)); };
var clearCacheValue = function (key) { return sessionStorage.removeItem(key); };
function useCache(key, defaultValue) {
    var state = getCacheValue(key) || defaultValue;
    var setState = function (value) {
        setCacheValue(key, value);
        state = tslib_1.__assign({}, value);
    };
    var clearState = function () {
        clearCacheValue(key);
    };
    return [state, setState, clearState];
}
exports.useCache = useCache;
//# sourceMappingURL=useCache.js.map